<!-- 素材库选择弹层 -->
<template>
  <div>
    <el-dialog
      title="从素材库选择"
      :visible.sync="dialogVisible"
      append-to-body
      width="80%"
      class="dialog-main1"
      :close-on-click-modal="false"
    >
      <div class="material-select-body">
        <div class="welcome-list">
          <materialManage :selectWelcome="selectWelcome" v-if="dialogVisible"></materialManage>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="dialogVisible = false"
          style="margin-right:20px"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="confirmSelectMateria"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChatMaterial } from "../../../api/mass/mass";
import materialManage from "../MaterialManagement.vue"
export default {
  name: "selectMaterialDialog",
  data() {
    return {
      dialogVisible: false,
      materialData: [], // 素材库数据
      materialData2: [],
      getDataParams: {
        current: "1",
        size: "999999",
      },
      selectResult: {},
      btnDisable: true,
      videoShow: false,
      videoUrl: "",
    };
  },
  components: {
    materialManage
  },
  computed: {},
  methods: {
    // 选中素材
    selectWelcome(data) {
      this.selectResult = data;
    },
    // 确定事件
    confirmSelectMateria() {
      this.$emit("confirmSelectMateria", this.selectResult);
      this.dialogVisible = false;
    },
    open() {
      this.btnDisable = true;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.dialog-main1 {
  // .el-dialog__footer{
  //     text-align: center;
  // }
  .welcome-list {
    height: 100%;
    padding: 0 0 6px 0;
    box-sizing: border-box;
    margin: 0;
    // max-height: 70vh;
    overflow: auto;
    .welcome-item {
      padding: 8px;
      cursor: pointer;
      list-style-type: none;
      margin: 0 !important;
      border-bottom: 1px solid #dcdfe6;
    }
    .welcome-item:hover {
      background: #d0f1ff;
    }
    .welcome-select {
      background: #d0f1ff;
    }
    &::-webkit-scrollbar {
      width: 3px;
      height: 8px;
      background-color: white;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(204, 204, 204, 0.3);
      border-radius: 5px;
      position: relative;
    }
  }
}
// 素材库弹窗
.material-select-body {
  width: 100%;
  height: 60vh;
  overflow: auto;
  .welcome-item {
    .item-text {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .item-image {
      display: flex;
      justify-content: flex-start;
      align-content: center;
    }
  }
}
.video-img {
  position: relative;
  .video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
